// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3d58eda4","453":"1ce52b38","455":"403c454c","889":"02600a6f","977":"9d7cc2bc"}[chunkId] + ".chunk.js";
};